import { createHash } from "crypto";

export function hashSchema(schema: string): string {
  return createHash("md5").update(schema).digest("hex");
}
